import VueBodyClass from '../router/body-class'

export default ({ debug, store, router }) => {
  return new Promise((resolve) => {
    debug && console.log('bootstrap.body', 'init');

    const routes = store.getters['ginger/getRoutes'];
    const bodyClass = new VueBodyClass(routes);

    // Initialization
    setTimeout(() => {
      bodyClass.guard(router.currentRoute, () => { 
        document.body.classList.add('theme-abc');
      });
    }, 500);

    // Route change
    router.beforeEach((to, from, next) => {
      bodyClass.guard(to, () => {
        next();
        document.body.classList.add('theme-abc');
      });
    })


    debug && console.log('bootstrap.body', 'completed');
    resolve();
  })
}
